<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <IDSKWarningText class="mt-4 mb-4 pr-2">
    {{ t('vyzvy.nepovinnyKrok') }}
  </IDSKWarningText>
</template>
